export class EdiDunsMaster{
    rowCheck: boolean;
    ediTpId:string;
    custName:string;
    sapPayerNum:string;
    isSaved:string;

    constructor(

        ediTpId : string,
        sapPayerNum : string,
        custName:string
    ){

        this.ediTpId =ediTpId ;
        this.custName =custName ;
        this.sapPayerNum =sapPayerNum ; 
         
        
    }
}